import React, { useState } from 'react';
import { Pencil } from 'lucide-react';


const InlineEdit = ({
    label,
    value,
    onSave,
    renderInput,
    fullWidth = false,
    alwaysEditing = false,
    hideLabel = false
}) => {
    const [isEditing, setIsEditing] = useState(false);

    // If alwaysEditing is true, we just render the input without save/cancel view mode
    // This is useful for Status which user requested to be always editable (dropdown)
    if (alwaysEditing) {
        return (
            <div className={fullWidth ? "w-full" : ""}>
                {!hideLabel && <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">{label}</div>}
                {renderInput({
                    save: (val) => onSave(val),
                    cancel: () => { },
                    isAlwaysEditing: true
                })}
            </div>
        );
    }

    const handleSave = (newValue) => {
        onSave(newValue);
        setIsEditing(false);
    };

    const handleCancel = () => {
        setIsEditing(false);
    };

    if (isEditing) {
        return (
            <div className={`relative ${fullWidth ? "w-full" : ""}`}>
                {!hideLabel && <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">{label}</div>}
                <div className="flex items-center gap-2">
                    <div className="flex-1">
                        {renderInput({
                            save: handleSave,
                            cancel: handleCancel
                        })}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`group relative ${fullWidth ? "w-full" : ""} flex items-center gap-2 hover:bg-gray-50 rounded-lg p-1 -m-1 transition-colors cursor-pointer`} onClick={() => setIsEditing(true)}>
            <div className="flex-1">
                {!hideLabel && <div className="text-xs text-gray-500 uppercase tracking-wide mb-0.5">{label}</div>}
                <div className="text-base font-medium text-gray-900">{value || <span className="text-gray-400 italic text-sm">Prázdne</span>}</div>
            </div>
            <div className="opacity-0 group-hover:opacity-100 transition-opacity text-primary-500">
                <Pencil size={14} />
            </div>
        </div>
    );
};

export default InlineEdit;
